var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';










const ToggleButton = ({
  children,
  onToggle,
  value,
  disabled,
  className = '',
  size = 'regular'
}) => {
  const checkedColor = disabled ? 'peer-checked:bg-primary-300' : 'peer-checked:bg-primary-600';

  const sizeClasses = {
    regular: {
      container: 'w-11 h-6',
      thumb: 'after:h-5 after:w-5 after:left-[2px] after:top-1/2 after:-translate-y-1/2'
    },
    small: {
      container: 'w-9 h-5',
      thumb: 'after:h-4 after:w-4 after:left-[2px] after:top-1/2 after:-translate-y-1/2'
    }
  };

  const currentSize = sizeClasses[size];

  return (/*#__PURE__*/
    _jsx("label", { className: "relative inline-flex items-center gap-2 cursor-pointer" }, void 0, /*#__PURE__*/
    _jsx("input", {
      type: "checkbox",
      value: value,
      className: `${className} sr-only peer`,
      disabled: disabled,
      onChange: onToggle,
      "data-testid": "toggle" }
    ), /*#__PURE__*/
    _jsx("div", {
      className: `${checkedColor} ${className} ${currentSize.container} bg-gray-200 rounded-full peer peer-checked:after:translate-x-full
        peer-checked:after:border-white after:content-[''] after:absolute
        after:bg-white after:border-gray-300 after:border after:rounded-full ${currentSize.thumb} after:transition-all` }
    ),
    children
    ));

};



export { ToggleButton };